/*
 * This program is part of the OpenCms Apollo Template.
 *
 * Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// Module implemented using the "revealing module pattern", see
// https://addyosmani.com/resources/essentialjsdesignpatterns/book/#revealingmodulepatternjavascript
// https://www.christianheilmann.com/2007/08/22/again-with-the-module-pattern-reveal-something-to-the-world/
var ApolloMap = function(jQ) {

    // all initialized Google maps
    this.m_maps = {};

    // all map data sets found on the page, as array for easy iteration
    this.m_mapData = [];

    // the Google geocode object, used for resolving coordinates to address names
    this.m_googleGeocoder = null;

    function getQueryVariable(variable)
    {
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return decodeURI(pair[1].replace(/\+/g, ' '));}
       }
       return(false);
    }

    function showMarkers(mapId, group) {

        if (DEBUG) console.info("showMapMarkers() called with map id: " + mapId);
        var map = m_maps[mapId];
        var markers = map.markers;
        var g = decodeURIComponent(group);
        hideAllInfo(mapId);
        for (var i = 0; i < markers.length; i++) {
            if (markers[i].group == g || g == 'showall') {
                markers[i].setVisible(true);
            } else {
                markers[i].setVisible(false);
            }
        }
    }


    function showInfo(mapId, infoId) {

        if (DEBUG) console.info("showInfo() called with map id: " + mapId + " info id: " + infoId);
        var map = m_maps[mapId];
        var infoWindows = map.infoWindows;
        for (var i = 0; i < infoWindows.length; i++) {
            if (i != infoId) {
                infoWindows[i].close();
            } else {
                if (infoWindows[i].geocode == "true") {
                    if (DEBUG) console.info("showInfo() geocode lookup for " + mapId);
                    getGeocode(infoWindows[i]);
                    infoWindows[i].geocode = "false";
                }
                infoWindows[i].open(
                    map,
                    infoWindows[i].marker
                );
            }
        }
    }


    function hideAllInfo(mapId) {

        if (DEBUG) console.info("hideAllInfo() called with map id: " + mapId);
        var map = m_maps[mapId];
        var infoWindows = map.infoWindows;
        for (var i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }
    }


    function setInfo(results, status, infoWindow) {

        if (DEBUG) console.info("setInfo() geocode lookup returned status " + status);
        var addressFound = "";
        if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
                addressFound = formatGeocode(results[0]);
            }
        } else {
            console.warn("Google GeoCoder returned error status '" + status + "' for coordinates " + infoWindow.marker.position);
        }
        // replace content in info window
        var infoContent = infoWindow.getContent();
        infoContent = infoContent.replace(/apolloAddr/, addressFound);
        infoWindow.setContent(infoContent);
    }


    function formatGeocode(result) {
        // returns the address from a geocode result in nicely formatted way
        var street = "";
        var strNum = "";
        var zip = "";
        var city = "";
        var foundAdr = false;

        for (var i = 0; i < result.address_components.length; i++) {
            var t = String(result.address_components[i].types);
            if (street == "" && t.indexOf("route") != -1) {
                street = result.address_components[i].long_name;
                foundAdr = true;
            }
            if (t.indexOf("street_number") != -1) {
                strNum = result.address_components[i].long_name;
                foundAdr = true;
            }
            if (t.indexOf("postal_code") != -1) {
                zip = result.address_components[i].long_name;
                foundAdr = true;
            }
            if (city == "" && t.indexOf("locality") != -1) {
                city = result.address_components[i].long_name;
                foundAdr = true;
            }
        }
        if (foundAdr == true) {
            return street + " " + strNum + "<br/>" + zip + " " + city;
        } else {
            return result.formatted_address;
        }
    }


    function getGeocode(infoWindow) {

        if (m_googleGeocoder == null) {
            // initialize global geocoder object if required
            m_googleGeocoder = new google.maps.Geocoder();
        }

        m_googleGeocoder.geocode({'latLng': infoWindow.marker.position}, function(results, status) {
            setInfo(results, status, infoWindow);
        });
    }


    function loadGoogleApi() {

        var locale = Apollo.getInfo("locale");
        var mapKey = ""
        if (Apollo.hasInfo("googleMapKey")) {
            mapKey = "&key=" + Apollo.getInfo("googleMapKey");
        }
        var addLibs = "";
        if (! Apollo.isOnlineProject()) {
            // need to load places API for OpenCms map editor
            addLibs = "&libraries=places"
        }
        if (DEBUG) console.info("googleMapKey: " + (mapKey == '' ? '(undefined)' : mapKey));
        jQ.loadScript("https://maps.google.com/maps/api/js?callback=ApolloMap.initGoogleMaps&language=" + locale + addLibs + mapKey);
    }


    function getPuempel(color) {
        return {
            scale: 1,
            fillOpacity: 1,
            fillColor: color,
            strokeColor: '#000000',
            strokeWeight: 1
        };
    }


    function initBranchMap(mapIndex) {
        var mapData = m_mapData[mapIndex];
        var mapId = mapData.id;
        var $map = jQ('#' + mapId);

        var map = m_maps[mapId];
        var markers = map.markers;

        if (!$map.hasClass('whc-branch-mapwindow')) return;

        var $wrap = $map.parents('.whc-branch-map');

        if (!$wrap.length) return;

        var $container = jQ('.whc-branch-list', $wrap);

        if (!$container.length) return;

        var $ddlTerritory;
        var $ddlDistrict;
        $ddlTerritory = jQ('#' + mapData.ddlTerritoryId);
        $ddlDistrict = jQ('#' + mapData.ddlDistrictId);
        
        var markerDatas = mapData.markers;
        var brandIdPrefix = mapId + '_';
        var scrollerOption = {
            cursorcolor: '#bebebe',
            cursorwidth: '10px',
            cursorborder: 0,
            cursorborderradius: 0,
            autohidemode: false,
            background: '#e6e6e6'
        };
        var scroller;
        if ($container.niceScroll) scroller = $container.niceScroll(scrollerOption);

        function pad(num, size) {
            var s = num+"";
            while (s.length < size) s = "0" + s;
            return s;
        }
        
        function updateDdlTerritory() {
            var territories = [];
            for(var i=0;i<markerDatas.length;i++) {
                var branch = markerDatas[i];
                if (branch.territory) territories.push(branch.territory);
            };
            territories = $.grep(territories, function(v, k){
                return $.inArray(v ,territories) === k;
            });
            $.each(territories, function (i, item) {
                $ddlTerritory.append(jQ('<option>', { 
                    value: item,
                    text : item 
                }));
            });
        }
        
        function updateDdlDistrict() {
            var selectedTerritory = $ddlTerritory.val();
            var districts = [];
            for(var i=0;i<markerDatas.length;i++) {
                var branch = markerDatas[i];
                if (branch.territory && branch.district && (!selectedTerritory || branch.territory == selectedTerritory)) districts.push(branch.district);
            };
            districts = $.grep(districts, function(v, k){
                return $.inArray(v ,districts) === k;
            });
            $ddlDistrict.find('option').not(':first').remove();
            $.each(districts, function (i, item) {
                $ddlDistrict.append(jQ('<option>', { 
                    value: item,
                    text : item 
                }));
            });
        }

        function changeDdlTerritoryHandler() {
            if ($ddlDistrict && $ddlDistrict.length) {
                $ddlDistrict.val('');
                updateDdlDistrict();
            }
            updateBranchList();
        }

        function changeDdlDistrictHandler() {
            updateBranchList();
        }

        function showBranchMarkers(territory, district) {
            var t = decodeURIComponent(territory);
            var d = decodeURIComponent(district);
            var currentNumber = 1;
            hideAllInfo(mapId);
            // for (var i = 0; i < markers.length; i++) {
            //     if (
            //         (markers[i].territory == t || t == '') &&
            //         (markers[i].district == d || d == '')
            //     ) {
            //         markers[i].setVisible(true);
            //         markers[i].setLabel({
            //             color: '#ffffff',
            //             text: pad(currentNumber++, 2)
            //         });
            //     } else {
            //         markers[i].setVisible(false);
            //         markers[i].setLabel('');
            //     }
            // }
        }

        function setCenter(index) {
            var marker;
            
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].index == index) {
                    marker = markers[i];
                    break;
                }
            }
            
            if (marker) {
                map.map.setCenter(marker.position);
                return true;
            }

            return false;
        }

        function clickLinkHandler(e) {
            e.preventDefault();

            var index = jQ(this).data('index');
            if (setCenter(index)) {
                if (!scroller || !scroller.cursorheight) {
                    var $wrap = jQ(this).parents('.whc-branch-map');
                    if ($wrap.length) jQ('html,body').scrollTop($wrap.offset().top - 15);
                }
            }
        }

        function updateBranchList() {
            var selectedTerritory = '';
            var selectedDistrict = '';
            var selectedBranchs = [];

            if ($ddlTerritory && $ddlTerritory.length) selectedTerritory = $ddlTerritory.val();
            if ($ddlDistrict && $ddlDistrict.length) selectedDistrict = $ddlDistrict.val();
            
            for(var i=0;i<markerDatas.length;i++) {
                var branch = markerDatas[i];
                if (branch.territory && branch.district && 
                    (!selectedTerritory || branch.territory == selectedTerritory) &&
                    (!selectedDistrict || branch.district == selectedDistrict))
                    selectedBranchs.push(branch);
            };

            $container.empty();
            if (scroller) scroller.doScrollTop(0, 0);

            if (!selectedBranchs.length) return;

            for(var i=0;i<selectedBranchs.length;i++) {
                var branch = selectedBranchs[i];
                var $block = jQ('<div/>').addClass('branchblock');
                var branchId = brandIdPrefix + i;

                
                var $basic = jQ('<div class="branchbasic" data-index="' + branch.index + '"></div>').click(clickLinkHandler);
                $basic.append(
                    jQ('<div class="branchanchor"></div>').append(
                        jQ('<div></div>')
                        .append(jQ('<span class="branchicon"></span>'))
                        .append(jQ('<span class="branchname"></span>').html(branch.title))
                    )
                ).append(
                    jQ('<div class="branchaddress"></div>').append(jQ('<p/>').html(branch.address))
                )
                $block.append($basic);
                var $details = jQ('<table/>');
                if (branch.email) $details.append(
                    jQ('<tr/>')
                    .append(jQ('<th/>').html(mapData.titleEmail || 'Email'))
                    .append(jQ('<td/>').html(branch.email))
                );
                if (branch.phone) $details.append(
                    jQ('<tr/>')
                    .append(jQ('<th/>').html(mapData.titlePhone || 'Phone'))
                    .append(jQ('<td/>').html(branch.phone))
                );
                if (branch.fax) $details.append(
                    jQ('<tr/>')
                    .append(jQ('<th/>').html(mapData.titleFax || 'Fax'))
                    .append(jQ('<td/>').html(branch.fax))
                );
                if (branch.businessHour) $details.append(
                    jQ('<tr/>')
                    .append(jQ('<th/>').html(mapData.titleBusinessHour || 'Business Hour'))
                    .append(jQ('<td/>').html(branch.businessHour))
                );
                if ($('> *', $details).length) {
                    $basic.append(jQ('<div class="branchdetails collapse" id="' + branchId + '"/>').append($details));
                    $block.append(jQ('<div class="branchanchorhideshow"><a data-toggle="collapse" href="#' + branchId + '" class="collapsed"><span class="branchanchorhide">' + (mapData.titleHide || 'Hide') + '</span><span class="branchanchorshow">' + (mapData.titleShowDetails || 'Show details') + '</span></a></div>'));
                }
                
                $container.append($block);
            }

            showBranchMarkers(selectedTerritory, selectedDistrict);
            setCenter(selectedBranchs[0].index);
        }
        
        map.map.setOptions({
            streetViewControl: mapData.streetViewControl == 'false' ? false : true,
            fullscreenControl: mapData.fullscreenControl == 'false' ? false : true,
            mapTypeControl: mapData.mapTypeControl == 'false' ? false : true,
        });
        
        for(var i=0;i<markerDatas.length;i++) {
            var branch = markerDatas[i];
            branch.index = i;
            var mapMarker = markers[i];
            var mapInfoWindow = map.infoWindows[i];
            mapMarker.territory = decodeURIComponent(branch.territory);
            mapMarker.district = decodeURIComponent(branch.district);
            // mapMarker.setIcon({
            //     path: 'M22-48h-44v43h16l6 5 6-5h16z',
            //     fillColor: '#000',
            //     fillOpacity: 1,
            //     strokeColor: '',
            //     strokeWeight: 0,
            //     scale: 0.6,
            //
            //     origin: new google.maps.Point(0, 0),
            //     anchor: new google.maps.Point(0, 0),
            //     labelOrigin: new google.maps.Point(0, -26)
            // });
            if (!mapMarker.info || mapMarker.info == 'undefined') {
                mapInfoWindow.setContent(decodeURIComponent('<h2>' + branch.title + '</h2>' + branch.address));
            }
        };
        
        if ($ddlTerritory && $ddlTerritory.length) {
            $ddlTerritory.on('change', changeDdlTerritoryHandler);
            updateDdlTerritory();
            if ($ddlDistrict && $ddlDistrict.length) {
                $ddlDistrict.on('change', changeDdlDistrictHandler);
                updateDdlDistrict();
            }
        }
        updateBranchList();
        

        var territory = getQueryVariable('territory');
        var district = getQueryVariable('district');
        if (territory && territory.length > 0) {
            $ddlTerritory.val(territory);
            $ddlTerritory.trigger('change');
        }
        if (district && district.length > 0) {
            $ddlDistrict.val(district);
            $ddlDistrict.trigger('change');
        }

        jQ(document).on('click', '.branchanchorhideshow', function() {
            setTimeout(function() {
                scroller.resize();
            }, 250);
        });
    }

    function initFindBranch() {
        var $map = jQ('.whc-branch-map-data');
        var mapId = $map.attr('id');
        var mapData = $map.data('map');

        if (!$map.hasClass('whc-branch-map-data')) return;

        var $wrap = $map.parents('.whc-branch-map');

        if (!$wrap.length) return;

        var $ddlTerritory;
        var $ddlDistrict;
        $ddlTerritory = jQ('#' + mapData.ddlTerritoryId);
        $ddlDistrict = jQ('#' + mapData.ddlDistrictId);
        
        var markerDatas = mapData.markers;
        var brandIdPrefix = mapId + '_';

        function pad(num, size) {
            var s = num+"";
            while (s.length < size) s = "0" + s;
            return s;
        }
        
        function updateDdlTerritory() {
            var territories = [];
            for(var i=0;i<markerDatas.length;i++) {
                var branch = markerDatas[i];
                if (branch.territory) territories.push(branch.territory);
            };
            territories = $.grep(territories, function(v, k){
                return $.inArray(v ,territories) === k;
            });
            $.each(territories, function (i, item) {
                $ddlTerritory.append(jQ('<option>', { 
                    value: item,
                    text : item 
                }));
            });
        }
        
        function updateDdlDistrict() {
            var selectedTerritory = $ddlTerritory.val();
            var districts = [];
            for(var i=0;i<markerDatas.length;i++) {
                var branch = markerDatas[i];
                if (branch.territory && branch.district && (!selectedTerritory || branch.territory == selectedTerritory)) districts.push(branch.district);
            };
            districts = $.grep(districts, function(v, k){
                return $.inArray(v ,districts) === k;
            });
            $ddlDistrict.find('option').not(':first').remove();
            $.each(districts, function (i, item) {
                $ddlDistrict.append(jQ('<option>', { 
                    value: item,
                    text : item 
                }));
            });
        }

        function changeDdlTerritoryHandler() {
            if ($ddlDistrict && $ddlDistrict.length) {
                $ddlDistrict.val('');
                updateDdlDistrict();
            }
        }
        
        if ($ddlTerritory && $ddlTerritory.length) {
            $ddlTerritory.on('change', changeDdlTerritoryHandler);
            updateDdlTerritory();
            if ($ddlDistrict && $ddlDistrict.length) {
                updateDdlDistrict();
            }
        }
    }


    function initGoogleMaps() {

        if (DEBUG) console.info("initGoogleMaps() called with data for " + m_mapData.length + " maps!" );

        for (var i=0; i < m_mapData.length; i++) {
            var mapData = m_mapData[i];

            var mapId = mapData.id;

            if (DEBUG) console.info("Initializing map: " + mapId);

            var mapOptions = {
                zoom: parseInt(mapData.zoom),
                scrollwheel: false,
                mapTypeId: eval("google.maps.MapTypeId." + mapData.type),
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DEFAULT,
                    mapTypeIds: new Array(
                        google.maps.MapTypeId.ROADMAP,
                        google.maps.MapTypeId.SATELLITE,
                        google.maps.MapTypeId.HYBRID
                    )
                },
                center: new google.maps.LatLng(mapData.centerLat, mapData.centerLng)
            }
            
            // create the map
            var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

            // enable mouse wheel scrolling after click
            google.maps.event.addListener(map, 'click', function(event){
                this.setOptions({scrollwheel:true});
            });

            // map markers and info windows
            var markers = [];
            var infoWindows = [];
            var groups = {};
            var groupsFound = 0;

            var icon = {
              url: '/o/.galleries/whcr/branch-navigate-icon.png',
              scaledSize: new google.maps.Size(25, 31),
              origin: new google.maps.Point(0,0),
              anchor: new google.maps.Point(12, 31)
            }

            if (typeof mapData.markers != "undefined") {
                for (var p=0; p < mapData.markers.length; p++) {

                    var point = mapData.markers[p];
                    var group = decodeURIComponent(point.group);
                    if (typeof groups[group] === "undefined" ) {
                        // Array? Object?
                        // see http://stackoverflow.com/questions/9526860/why-does-a-string-index-in-a-javascript-array-not-increase-the-length-size
                        var color = Apollo.getThemeColor("map-color[" + groupsFound++ + "]");
                        if (DEBUG) console.info("Map new marker group added: " + group + " with color: " + color);
                        groups[group] = getPuempel(color);
                    }

                    // get marker data from calling object
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(point.lat, point.lng),
                        map: map,
                        title: decodeURIComponent(point.title),
                        group: group,
                        icon: icon,
                        info: decodeURIComponent(point.info),
                        index: p,
                        mapId: mapId,
                        geocode: point.geocode
                    });

                    // add marker to marker map
                    markers.push(marker);

                    // initialize info window
                    var infoWindow = new google.maps.InfoWindow({
                        content: marker.info,
                        marker: marker,
                        geocode: point.geocode,
                        index: p
                    });

                    // add marker to marker map
                    infoWindows.push(infoWindow);

                    if (DEBUG) console.info("attaching Event lister: " + p + " to map id " + mapId);

                    // attach event listener that shows info window to marker
                    // see http://you.arenot.me/2010/06/29/google-maps-api-v3-0-multiple-markers-multiple-infowindows/
                    marker.addListener('click', function() {
                        showInfo(this.mapId, this.index);
                    });
                }
            }

            // store map in global array, required e.g. to select marker groups etc.
            var map = {
                'id': mapId,
                'map': map,
                'markers': markers,
                'infoWindows': infoWindows
            };
            m_maps[mapId] = map;

            initBranchMap(i);
        }
    }

    function init() {

        if (DEBUG) {
            console.info("ApolloMap.init()");
            if (Apollo.hasInfo("googleMapKey")) {
                // Goggle map key is read in apollo:pageinfo tag and read to JavaScript via Apollo.init()
                console.info("Google map key is: " + Apollo.getInfo("googleMapKey"));
            } else {
                console.info("Google map key not set in OpenCms VFS!");
            }
        }

        var $mapElements = jQ('.ap-google-map');
        if (DEBUG) console.info(".ap-google-map elements found: " + $mapElements.length);

        if ($mapElements.length > 0) {
            // load the Google map API
            loadGoogleApi();

            // initialize map sections with values from data attributes
            $mapElements.each(function(){
                var $element = jQ(this);
                var $mapElement = $element.find('.mapwindow');
                var $mapData = $element.find('.whc-branch-map-data');

                if (typeof $mapElement.data("map") != 'undefined') {
                    var mapData = $mapElement.data("map");
                    mapData.id = $mapElement.attr("id");
                    if (DEBUG) console.info("mapData found:" + mapData + ", id=" + mapData.id);
                    m_mapData.push(mapData);
                }

                if (typeof $mapData.data("map") != 'undefined') {
                    var mapData = $mapData.data("map");
                    mapData.id = $mapData.attr("id");
                    if (DEBUG) console.info("mapData found:" + mapData + ", id=" + mapData.id);

                    initFindBranch();
                }
            });
            setTimeout(function(){ 
                var $notabElement = jQ(".notab");
                $notabElement.find('*').attr('tabindex', -1);
             }, 3000);
        }

    }

    // public available functions
    return {
        init: init,
        initGoogleMaps: initGoogleMaps,
        showMarkers: showMarkers
    }

}(jQuery);

